import { createFileRoute } from '@tanstack/react-router'
import SistemaPage from '@/pages/dashboard/sistema-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/',
)({
  component: function SistemaRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <SistemaPage />
      </ProtectedRoute>
    )
  },
})
